import { useAppSelector } from "@/lib/redux/hooks"
import { useTour } from "./useTour"
import { useMemo } from "react"

export const useTourPrice = () => {
  const { tour: { data: tour } } = useTour()
  const inputTour = useAppSelector(state => state.tour.inputTour)
  
  const departureSchedule = useMemo(() => {
    if (!inputTour.selectedDepartureSchedule) {
      return null
    }
    return tour?.departureSchedule?.find(d => d.id === inputTour.selectedDepartureSchedule)
  }, [inputTour.selectedDepartureSchedule, tour?.departureSchedule])

  return useMemo(() => {
    if (!departureSchedule){
      return {
        totalAmount: 0
      }
    }
    return {
      chd1Price: inputTour.inputChd1 * (departureSchedule?.prices[0]?.priceChd1),
      chd2Price: inputTour.inputChd2 * (departureSchedule?.prices[0]?.priceChd2),
      infPrice: inputTour.inputInf * (departureSchedule?.prices[0]?.priceInf),
      adtPrice: inputTour.inputAdt * (departureSchedule?.prices[0]?.priceAdt),
      totalAmount: (inputTour.inputAdt * (departureSchedule?.prices[0]?.priceAdt)) + 
      (inputTour.inputChd1 * (departureSchedule?.prices[0]?.priceChd1)) +
      (inputTour.inputChd2 * (departureSchedule?.prices[0]?.priceChd2)) +
      (inputTour.inputInf * (departureSchedule?.prices[0]?.priceInf)),
      inputTour
    }
  }, [departureSchedule, inputTour])
}